import { render, staticRenderFns } from "./DocEditPreview.vue?vue&type=template&id=a868a8e8&"
import script from "./DocEditPreview.vue?vue&type=script&lang=js&"
export * from "./DocEditPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports